module.exports = "/_next/static/images/UDJ4-0df7d7d9fb2f40a8485f7474935e9010.svg";